import { inject, Service } from "@angular/core";
import { Translation, TranslocoService } from "@jsverse/transloco";
import { isDefined } from "@recursyve/nice-ts-utils";
import { Observable } from "rxjs";

@Service()
export class LanguagePreloadService {
    private readonly translocoService = inject(TranslocoService);

    public preload(): Observable<Translation> {
        const browserLanguage = this.getBrowserLanguage();
        const activeLanguage = this.getActiveSupportedLanguage(browserLanguage);
        this.translocoService.setDefaultLang(activeLanguage);
        return this.translocoService.load(activeLanguage);
    }

    private getActiveSupportedLanguage(activeLanguage: string): string {
        const isSupportedLanguage = this.translocoService.isLang(activeLanguage);
        if (isSupportedLanguage) {
            return activeLanguage;
        }

        return this.translocoService.getDefaultLang();
    }

    private getBrowserLanguage(): string {
        const browserLanguage = localStorage.getItem("lang");
        if (isDefined(browserLanguage)) {
            return browserLanguage;
        }

        return this.translocoService.getDefaultLang();
    }
}
